export function normalizeDealPurpose(value) {
  const purpose = String(value ?? "").trim().toLowerCase();
  return purpose === "combination" || purpose === "combined" ? "combined" : purpose;
}

export function isCombinationPurpose(value) {
  return normalizeDealPurpose(value) === "combined";
}

export function computeRefundingRequirement(refundedIssues = []) {
  if (!Array.isArray(refundedIssues)) return 0;
  return refundedIssues.reduce((sum, entry) => {
    if (String(entry?.entry_type ?? entry?.entryType ?? "manual").toLowerCase() === "ds_issue") {
      return sum;
    }
    const raw = entry?.deposit_amount ?? entry?.depositAmount ?? entry?.amount ??
      entry?.deposit ?? entry?.deposit_required ?? entry?.depositRequirement;
    const amount = Number(raw);
    return sum + (Number.isFinite(amount) && amount > 0 ? amount : 0);
  }, 0);
}

export function getCombinationRequirements(form = {}) {
  const value = Number(form?.targetValue ?? form?.target_value);
  const newMoneyRequirement = Number.isFinite(value) && value > 0 ? value : 0;
  const refundingRequirement = computeRefundingRequirement(
    form?.refunded_issues ?? form?.refundingManualDeposits
  );
  return {
    newMoneyRequirement,
    refundingRequirement,
    totalRequirement: newMoneyRequirement + refundingRequirement,
  };
}

export function getCombinationSolverTarget(form = {}) {
  const requirements = getCombinationRequirements(form);
  return String(form?.targetType ?? form?.target_type ?? "").toLowerCase() === "par_amount"
    ? requirements.newMoneyRequirement
    : requirements.totalRequirement;
}
